import React from "react";
import Navigation from "../components/Navigation";
import Hero from "../components/Hero";
import ChartersSection from "../components/ChartersSection";
import PartnerChartersSection from "../components/PartnerChartersSection";
import AboutSection from "../components/AboutSection";
import DestinationsSection from "../components/DestinationsSection";
import FleetSection from "../components/FleetSection";
import ReviewsSection from "../components/ReviewsSection";
import FaqSection from "../components/FaqSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";

const HomePage = () => {
  return (
    <div data-testid="home-page">
      <Navigation />
      <Hero />
      <ChartersSection />
      <PartnerChartersSection />
      <AboutSection />
      <DestinationsSection />
      <FleetSection />
      <ReviewsSection />
      <FaqSection />
      <ContactSection />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default HomePage;
